import React, { forwardRef, useEffect } from 'react';
import YouTube from 'react-youtube';

const VideoPlayer = forwardRef(({ videoId, startTime, endTime, onDurationChange }, ref) => {
  const onReady = (event) => {
    ref.current = event.target;
    ref.current.seekTo(startTime, true);
    onDurationChange(ref.current.getDuration());
  };

  useEffect(() => {
    if (ref.current) {
      ref.current.seekTo(startTime, true);
    }
  }, [startTime]);

  const opts = {
    height: '390',
    width: '640',
    playerVars: {
      autoplay: 0,
      start: startTime,
      end: endTime,
      controls: 1,
    },
  };

  return (
    <div>
      <YouTube videoId={videoId} opts={opts} onReady={onReady} />
    </div>
  );
});

export default VideoPlayer;
